// @ts-check
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FlexLib from '@flex/lib';
import AmountTextField from './AmountTextField';

const { getCustomLabel, formatFeeType } = FlexLib.utils.feeService;
/**
 * Use for individual fee fields outside of FeeDisplay (ex. Virtual Terminal) to get correct label
 * @param {{id: string, labelPrefix: string, setAmount: (value: string) => void, precision: number, disabled: boolean, required: boolean, variant: string, fee: Fee, databaseFeeSettings: DatabaseFeeSettings}} props
 * @returns {*}
 */
const FeeAmountTextField = (props) => {
  /** @type {Fee} } */
  const fee = props.fee;

  /** @type {DatabaseFeeSettings} */
  const feeSettings = props.databaseFeeSettings;

  const [feeLabel, setFeeLabel] = useState('');

  useEffect(() => {
    if (fee?.name && feeSettings) {
      const labelPrefix = props.labelPrefix ? `${props.labelPrefix} ` : '';
      setFeeLabel(
        `${labelPrefix} ${getCustomLabel(fee.name, feeSettings)} (${formatFeeType(
          fee.type,
          fee.value.stored,
          fee.name
        )})`
      );
    }
  }, [fee?.name, fee?.type, fee?.value.stored, feeSettings, props.labelPrefix]);

  return fee?.display ? (
    <AmountTextField
      id={props.id ?? `${fee.name}-amount`}
      label={feeLabel}
      amount={fee.amount}
      setAmount={props.setAmount}
      precision={props.precision}
      disabled={props.disabled}
      required={props.required}
      variant={props.variant}
      fullWidth
    />
  ) : (
    <></>
  );
};

FeeAmountTextField.propTypes = {
  id: PropTypes.string,
  labelPrefix: PropTypes.string,
  setAmount: PropTypes.func,
  precision: PropTypes.number,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  variant: PropTypes.string,
  fee: PropTypes.shape({
    name: PropTypes.string.isRequired,
    display: PropTypes.bool.isRequired,
    type: PropTypes.oneOf(['$', '%']).isRequired,
    amount: PropTypes.string.isRequired,
    value: PropTypes.shape({
      stored: PropTypes.string.isRequired,
      calculated: PropTypes.string.isRequired,
    }),
  }).isRequired,
  databaseFeeSettings: PropTypes.object.isRequired,
};
export default FeeAmountTextField;

/**
 * @typedef {import('../../../../types/fees').Fee } Fee
 * @typedef {import('../../../../types/fees').DatabaseFeeSettings} DatabaseFeeSettings
 */
